const numberInput = {
  root: {
    transitionDuration: '{transition.duration}',
  },
  colorScheme: {
    light: {
      button: {
        background: '{grayScale.200}',
        hoverBackground: '{grayScale.400}',
      },
    },
  },
};

export default numberInput;
